import React from 'react';
import axios from 'axios';
import moment from 'moment';
import qs from 'qs';
import nl2br from 'react-nl2br';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import CircularProgress from '@material-ui/core/CircularProgress';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import VisibilityIcon from '@material-ui/icons/Visibility';
import FileScanIcon from "./FileScanIcon";

const styles = () => ({
  root: {
    width: '100%',
  },
  wrapperDate: {
    textAlign: 'center',
    fontSize: 18,
    fontWeight: 'bold',
    padding: 20,
  },
  wrapperMessage: {
    padding: 20,
  },
  wrapperMessageDeleted: {
    '& .text': {
      backgroundColor: '#ddd !important',
    },
  },
  wrapperMessageTypeMy: {
    textAlign: 'right',
    '& .text': {
      backgroundColor: '#e8f5e9',
      marginRight: 0,
      marginLeft: 'auto',
      textAlign: 'left',
    },
  },
  wrapperMessageTypeOther: {
    textAlign: 'left',
    '& .text': {
      backgroundColor: '#e3f2fd',
    },
  },
  messageContentText: {
    display: 'inline-block',
    padding: 20,
    borderRadius: 10,
    maxWidth: '65%',
    position: 'relative',
  },
  messageFooter: {
    color: '#9e9e9e',
    fontSize: 12,
  },
  messageFooterTime: {
    display: 'inline-block',
    marginLeft: 20,
  },
  menuButton: {
    marginLeft: 10,
  },
  fileWrapper: {
    marginTop: 20,
  },
  fileWrapperStatus: {
    marginTop: 10,
  },
  hasReadWrapper: {
    position: 'absolute',
    bottom: -5,
    right: 2,
    color: 'rgba(0, 0, 0, 0.26)',
  },
  buttonIcon: {
    verticalAlign: 'text-top',
  },
  mutedText: {
    color: '#bdbdbd',
  }
});

const mapStateToProps = state => {
  return {
    messagesSelectedThread: state.messagesSelectedThread,
    selectedPupil: state.selectedPupil,
  };
};

class MessageThreadMessagesEntry extends React.Component {
  constructor(props) {
    super(props);

    const isMessage = props.data && props.data.type === 'message';
    const text = isMessage
      ? props.data.data.text
      : '';

    this.state = {
      text,
      isLoading: false,
      isLoaded: !isMessage || (isMessage && !!text),
      anchorEl: null,
    };

    this.axiosCancel = null;
  }

  componentDidMount() {
    const {
      selectedPupil,
      messagesSelectedThread,
      data,
    } = this.props;
    const {
      isLoaded,
    } = this.state;

    if (isLoaded) {
      return;
    }

    const apiUrl = `${window.apiMessagingUrl}/getmessagesforthread`;
    let apiParams = {
      thread_id: messagesSelectedThread.thread.id,
      message_id: data.data.id-1,
      direction: 'forward',
      limit: 1,
    };

    if (selectedPupil) {
      apiParams.pupil_id = selectedPupil.id;
    }

    this.setState({
      isLoading: true,
    });

    axios
      .post(
        apiUrl,
        qs.stringify(apiParams),
        {
          cancelToken: new axios.CancelToken((c) => { this.axiosCancel = c }),
        }
      )
      .then((response) => {
        if (response.data.data.length > 0) {
          this.setState({
            text: response.data.data[0].text,
            isLoaded: true,
            isLoading: false,
          });
        }
      })
      .catch((thrown) => {});
  }

  componentWillUnmount() {
    if (this.axiosCancel) {
      this.axiosCancel();
    }
  }

  render() {
    const {
      classes,
      t,
      data,
      otherName,
      onDeleteClick,
      enqueueSnackbar,
    } = this.props;
    const {
      text,
      isLoading,
      isLoaded,
      anchorEl,
    } = this.state;
    const entryData = data.data;

    let isDeleted = false;
    let showDelete = false;
    let messageWrapperClass = classes.wrapperMessage;
    if (data.type === 'message') {
      isDeleted = entryData.deleted === 'yes';
      showDelete = !isDeleted &&
      (
        appType === 'teacher' ||
        appType === 'teacher_admin'
      );

      if (data.ownership === 'other') {
        messageWrapperClass = isDeleted
          ? `${classes.wrapperMessage} ${classes.wrapperMessageTypeOther} ${classes.wrapperMessageDeleted}`
          : `${classes.wrapperMessage} ${classes.wrapperMessageTypeOther}`;
      } else {
        messageWrapperClass = isDeleted
          ? `${classes.wrapperMessage} ${classes.wrapperMessageTypeMy} ${classes.wrapperMessageDeleted}`
          : `${classes.wrapperMessage} ${classes.wrapperMessageTypeMy}`;
      }
    }

    return (
      <div className={`message-thread-messages-entry ${classes.root}`}>
        {data.type === 'date' && (
          <div className={classes.wrapperDate}>
            {moment(entryData).format('dddd, D MMMM YYYY')}
          </div>
        )}
        {data.type === 'message' && (
          <div className={messageWrapperClass}>
            <div>
              <div className={'text ' + classes.messageContentText}>
                {!isLoaded && isLoading && (
                  <CircularProgress />
                )}
                {isLoaded && (
                  <span className={entryData.is_file && entryData.file_scan_status !== 'pass' ? classes.mutedText : ''}
                    >{nl2br(text)}</span>
                )}
                {showDelete && (
                  <span>
                    <IconButton
                      size="small"
                      onClick={(event) => {
                        this.setState({
                          anchorEl: event.currentTarget,
                        });
                      }}
                      className={`dropdown-button ${classes.menuButton}`}
                    >
                      <KeyboardArrowDownIcon fontSize="small" />
                    </IconButton>
                    <Menu
                      anchorEl={anchorEl}
                      keepMounted
                      open={Boolean(anchorEl)}
                      onClose={() => {
                        this.setState({
                          anchorEl: null,
                        });
                      }}
                    >
                      <MenuItem
                        onClick={onDeleteClick.bind(this, entryData)}
                        className="arcive-menu-item"
                      >
                        {t('Archive')}
                      </MenuItem>
                    </Menu>
                  </span>
                )}
                {entryData.is_file && (
                  <div className={classes.fileWrapper}>
                    {entryData.file_scan_status === 'pass' && (
                      <div>
                        <a
                          href={typeof canAllowDownloads && !canAllowDownloads ? '#' : entryData.file}
                          target={typeof isIosApp !== 'undefined' && isIosApp ? '_system' : '_blank'}
                          onClick={(event) => {
                            if (typeof canAllowDownloads && !canAllowDownloads) {
                              event.preventDefault();

                              enqueueSnackbar(t('You do not have the permissions to do this'), {
                                variant: 'error',
                                autoHideDuration: 2000,
                              });
                            }
                          }}
                        >
                          {t('Download attachment')}
                        </a>
                      </div>
                    )}
                    {entryData.file_scan_status !== 'pass' && (
                      <div className={classes.fileWrapperStatus}>
                        <FileScanIcon className={classes.buttonIcon} scan_status={entryData.file_scan_status}/>&nbsp;
                        <small>{entryData.file_scan_status_message}</small>
                      </div>
                    )}
                  </div>
                )}
                {data.has_read && (
                  <div className={classes.hasReadWrapper}>
                    <VisibilityIcon />
                  </div>
                )}
              </div>
            </div>
            <div className={classes.messageFooter}>
              {data.ownership === 'other' && (
                <span>{otherName}</span>
              )}
              <span className={classes.messageFooterTime}>
                {moment(entryData.timestamp).format(dateFormat + ' HH:mm')}
              </span>
              {isDeleted && (
                <div>{t('This message was archived')}</div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps)(
  withSnackbar(withStyles(styles)(withTranslation()(MessageThreadMessagesEntry)))
);
